import { render } from "./domainsServices.vue?vue&type=template&id=8f4772a0&scoped=true"
import script from "./domainsServices.vue?vue&type=script&lang=js"
export * from "./domainsServices.vue?vue&type=script&lang=js"

import "./domainsServices.vue?vue&type=style&index=0&id=8f4772a0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4772a0"]])

export default __exports__